import type { IntlShape } from 'react-intl'
import { getHolidaySynonymLabels } from 'hooks/useHolidaySynonymLabels'
import { minimumBalances } from 'constants/creditSnackbar'
import { isTooSoonToShowSnackbar } from 'storage/creditsSnackbar'
import { formatDynamicAmount } from 'lib/format/formatCurrencyIntl'
import { contains } from 'lib/string/stringUtils'

export function shouldShowCreditSnackbar(balance: number, currentCurrency: string, pathname: string, userId: string, headless: boolean) {
  return (
    balance >= minimumBalances[currentCurrency] &&
    pathname &&
    !headless &&
    !contains(pathname, '/account/my-escapes/order/') &&
    !contains(pathname, '/booking/confirmation') &&
    !contains(pathname, '/support') &&
    !isTooSoonToShowSnackbar(userId))
}

export function getCreditSnackbar(intl: IntlShape, balance: number, currentCurrency: string, regionCode: string) {
  return {
    heading: intl.formatMessage(
      {
        id: 'a9LMyyOWTNAQCClgRqhu',
        defaultMessage: 'You have {formattedBalance} credit to spend!',
        description: 'Credit snackbar heading showing available credit balance',
      },
      { formattedBalance: formatDynamicAmount(balance, currentCurrency, regionCode) },
    ),
    message: getHolidaySynonymLabels(intl).creditSnackbarMessage,
  }
}
